<template>
  <div >
    <div class="wizard__header" v-html="this.header">
    </div>

    <div class="wizard__review" v-equalizer>
        <section>
            <p><strong>{{ data.firstName }} {{ data.lastName }}</strong></p>
            <p v-text="data.email"></p>
            <p v-text="data.phoneNumber"></p>
        </section>
        <section>
            <small>Moving From Address</small>
            <p>{{ data.movingFromAddress }} <br> {{ data.movingFromCity }}, {{ data.movingFromState }} {{ data.movingFromZip }}</p>
            <small>Moving To Address</small>
            <p>{{ data.movingToAddress }} <br> {{ data.movingToCity }}, {{ data.movingToState }} {{ data.movingToZip }}</p>
        </section>
        <div class="section--group">
            <section>
                <small>Desired Move Date</small>
                <p v-text="data.desiredMoveDate"></p>
            </section>
            
            <section v-if="data.walkthroughDate != undefined">
                <small v-if="data.walkthroughType.toLowerCase() == 'on-site'">Scheduled On-Site Walkthrough Date & Time</small>
                <small v-if="data.walkthroughType.toLowerCase() == 'virtual'">Scheduled Virutal/Video Walkthrough Date & Time</small>
                <p v-text="data.walkthroughDate + ' ' + data.walkthroughTime"></p>
            </section>
        </div>
        <div class="section--group">
            <section v-if="data.numberOfMovingHours != undefined && data.size == '1-2 Br'">
                <small>Number of Hours Requested</small>
                <p v-text="data.numberOfMovingHours"></p>
            </section>
            
            <section v-if="data.numbrerOfBoxesPackedByUs != undefined && data.packing != 'No'">
                <small># of Packing Boxes</small>
                <p v-text="data.numbrerOfBoxesPackedByUs"></p>
            </section>
        </div>
        <section>
            <small>Estimated Total Cost</small>
            <p>{{ data.estimatedTotal }}</p>
        </section>
        <ul class="wizard__nav" v-if="onPrevious">
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--previous" @click.prevent="onPrevious">Previous</a></li>
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--next" @click.prevent="nextClickHandler">Confirm</a></li>
    </ul>
    </div>
  </div>
</template>

<script>
import NumericInput from './NumericInput';
import { bedroomSizeValues, initialBoxCount } from '../classes/Globals';
  export default {
    props: {
        onResponse: {
            type: Function
        },

        onPrevious: {
            type: Function
        },

        header: {
            type: String
        },

        data: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        name: "Review"
    }),

    computed: {
        selectionsLabel() {
            return `${(this.data.size || "").replace(
                "Br",
                "bedroom"
            )}, ${(this.data.distance || "").toLowerCase() === "local" ? "local move" : "long distance move"}, ${this.data.packing.toLowerCase() === 'no' ? 'self-packing' : 'mover-packing'}`;
        }
    },

    mounted() {
    },

    methods: {

        nextClickHandler() {

            this.onResponse({
                response: true
            });
        }
    },
    components: {
        NumericInput
    }
  };
</script>
